class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;

    // If this is a nested submenu column inside header navigation, keep it permanently open and do not attach focusout
    if (this.closest('.header__submenu') || this.closest('.list-menu--disclosure') || (this.parentElement && this.parentElement.closest('details'))) {
      this.mainDetailsToggle.setAttribute('open', '');
      return;
    }

    this.content = this.mainDetailsToggle.querySelector('summary') ? this.mainDetailsToggle.querySelector('summary').nextElementSibling : null;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.closest('.header__submenu') || this.closest('.list-menu--disclosure') || (this.parentElement && this.parentElement.closest('details'))) {
        return;
      }
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.content) return;
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
      
      // Ensure all child columns in mega menu stay open
      const childDetails = this.mainDetailsToggle.querySelectorAll('details');
      childDetails.forEach((d) => {
        d.setAttribute('open', '');
        const summary = d.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      });
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (this.closest('.header__submenu') || (this.parentElement && this.parentElement.closest('details'))) {
      return;
    }
    this.mainDetailsToggle.removeAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    super.onToggle();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
